<p class="sample-description">
  The <code>Actions</code> column uses <code>ButtonsCellRenderer</code>. The <code>View</code> button is hidden
  via a computed signal based on each row's <code>isLiving</code> value.
</p>

<ui-grid
  [readEndpoint]="'mock/StarWarsActors'"
  [columnDefs]="colDefs"
  [showPanelHeader]="true"
  [panelHeaderConfig]="panelHeaderConfig"
  [agGridOptions]="{ paginationPageSize: 5 }"
  [pageSizes]="[5, 10, 20]"
></ui-grid>

